import axios from 'axios';

export default axios.create({
  baseURL: 'https://server.greeneffect.co.kr:28080',
});
